interface UseCalendarInputProps {}

const useCalendarInput = (props: UseCalendarInputProps) => {
  return {}
}
export default useCalendarInput
